// GENERATED AT BUILD TIME — DO NOT EDIT
export const BUILD_INFO = {
  version: '17.0.0',
  commit: 'b98c6da',
  builtAt: '2026-10-03T12:09:47.943Z',
} as const;
